import { ValidationSchema } from "_core/form";
import { ErrorMessages } from "_core/types";
import { isPostcode } from "_core/utils";

export type FormValues = {
  addressLine1: string;
  addressLine2: string;
  billingAddressLine1: string;
  billingAddressLine2: string;
  billingAddressSame: boolean;
  billingCity: string;
  billingPostcode: string;
  city: string;
  consent: boolean;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  postcode: string;
  privacyPolicy: boolean;
};

export const PaymentValidator: ValidationSchema<FormValues> = {
  privacyPolicy: ({ privacyPolicy }) => {
    if (!privacyPolicy) return ErrorMessages.REQUIRED;
  },
  consent: ({ consent }) => {
    if (!consent) return ErrorMessages.REQUIRED;
  },
  billingAddressLine1: ({ billingAddressLine1 }) => {
    if (!billingAddressLine1) return ErrorMessages.REQUIRED;
  },
  billingCity: ({ billingCity }) => {
    if (!billingCity) return ErrorMessages.REQUIRED;
  },
  billingPostcode: ({ billingPostcode }) => {
    if (!billingPostcode) return ErrorMessages.REQUIRED;
    if (!isPostcode(billingPostcode)) return ErrorMessages.INVALID_POSTCODE;
  },
};
